import React from "react";
import Footer from "./footer";
import Navbar from "./navbar";
import baseUrl from "../base_url";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import OrdersSkeleton from "./components/orderSkeleton";

function ParticularOrder(props) {
  return (
    <div className="flex items-center py-4">
      <div className="w-24 h-24 flex-shrink-0">
        <Link to={`/productpage/${props.productId}`}>
          <img
            src={props.img}
            alt="product"
            className="w-full h-full object-contain"
          />
        </Link>
      </div>
      <div className="ml-4 flex-grow">
        <Link to={`/productpage/${props.productId}`} className="text-blue-600 text-sm md:text-lg  hover:underline font-medium">
          {props.name}
        </Link>
        <p className="text-xs md:text-sm text-gray-500 mt-1">Quantity: {props.quantity}</p>
        <p className="text-xs md:text-sm font-medium mt-1">Rs. {props.price}</p>
      </div>
    </div>
  );
}
function StatusBadge({ status }) {
  let bgColor = "bg-gray-100";
  let textColor = "text-gray-800";
  let ringColor = "ring-gray-400";
  
if (status === "Delivered") {
  bgColor = "bg-green-100";
  textColor = "text-green-800";
  ringColor = "ring-green-400";
} else if (status === "Shipped") {
  bgColor = "bg-blue-100";
  textColor = "text-blue-800";
  ringColor = "ring-blue-400";
} else if (status === "Processing") {
  bgColor = "bg-yellow-100";
  textColor = "text-yellow-800";
  ringColor = "ring-yellow-400";
} else if (status === "Cancelled") {
  bgColor = "bg-red-100";
  textColor = "text-red-800";
  ringColor = "ring-red-400";
} else if (status === "Placed") {
  bgColor = "bg-purple-100";
  textColor = "text-purple-800";
  ringColor = "ring-purple-400";
} else if (status === "Return Requested") {
  bgColor = "bg-orange-100";
  textColor = "text-orange-800";
  ringColor = "ring-orange-400";
} else if (status === "Return Approved") {
  bgColor = "bg-indigo-100";
  textColor = "text-indigo-800";
  ringColor = "ring-indigo-400";
} else if (status === "Return Pickup Initiated") {
  bgColor = "bg-cyan-100";
  textColor = "text-cyan-800";
  ringColor = "ring-cyan-400";
} else {
  // default in case status doesn't match
  bgColor = "bg-gray-100";
  textColor = "text-gray-800";
  ringColor = "ring-gray-400";
}
  
  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${bgColor} ${textColor} ring-1 ring-inset ${ringColor}`}>
      {status}
    </span>
  );
}

function ProductOrdered(props) {
  const orderStatus = props.status;
  const isDelivered = orderStatus === "Delivered";
  const isShipped = orderStatus === "Shipped";
  const isProcessing = orderStatus === "Processing";
  const isCancelled = orderStatus === "Canceled";
  const isPlaced = orderStatus === "Placed";
  const isReturned = orderStatus === "Return Requested";

  const returnRequested = orderStatus === "Return Requested";
  const returnApproved = orderStatus === "Return Approved";
  const returnInitiated = orderStatus === "Return Pickup Initiated";
  const refunded = orderStatus === "Refunded";
  const returnInProgress = orderStatus === "Return in Progress"
  const returnRejected = orderStatus === "Return Rejected"
  
  // Format order date (this would use the actual date from your data)
  const orderDate = new Date().toLocaleDateString('en-IN', {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  });
  
  // Format delivery date (this is simplified and would use real data)

  

const returnDate = isDelivered && props?.order?.deliveryDate
  ? new Date(new Date(props.order.deliveryDate).setDate(new Date(props.order.deliveryDate).getDate() + 6))
      .toLocaleDateString('en-IN', {
        day: 'numeric',
        month: 'long',
        year: 'numeric'
      })
  : "";

const deliveryDate = isDelivered ? 
    new Date(props.order.deliveryDate).toLocaleDateString('en-IN', {
      day: 'numeric',
      month: 'long'
    }) : "";

    const canBeReturned = (order) => {
      if (!order.deliveryDate) return false;
      const deliveryDate = new Date(order.deliveryDate);
      const currentDate = new Date();
      const timeDifference = currentDate - deliveryDate;
      const daysDifference = Math.floor(timeDifference / (1000 * 60 * 60 * 24)) + 1;
      return daysDifference <= 7;
    };

    const canReturned = canBeReturned(props.order);
    
    // Show track package button for shipped orders with tracking info
    const showTrackPackage = props.order.tracking !== "NA" && (isShipped || isProcessing) && !isDelivered && !isReturned;
    
    // Show cancel order button for new orders that are placed or processing
    const showCancelOrder = isPlaced || isProcessing;
    
    // Show return button for delivered orders within return window
    const showReturn = isDelivered && canReturned;
    

  const handleInvoice = async () => {
    try {

      console.log(props)


      const invoiceUrl =  props.order.invoice;
      // console.log('Invoice URL:', invoiceUrl);

      if (invoiceUrl) {
        // Second request to download the PDF
        const pdfResponse = await axios.get(invoiceUrl, {
          responseType: 'blob' 
        });

        // Create a blob URL and trigger download
        const url = window.URL.createObjectURL(new Blob([pdfResponse.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `invoice_${props._id}.pdf`);
        document.body.appendChild(link);
        link.click();

        // Clean up
        link.parentNode.removeChild(link);
        window.URL.revokeObjectURL(url);

        alert('Invoice downloaded successfully!');
      } else {
        throw new Error('No invoice URL received');
      }
    } catch (err) {
      console.error('Failed to download invoice:', err);
      alert('Failed to download invoice');
    } 
  };

  const HandleCancel = (props)=>{

    console.log(props)
    const isConfirmed = window.confirm("are you sure that you want to cancel this order ??")
    
    const id = props._id

    if(isConfirmed){
      async function handleCancel(){
        try{
          const accessToken = localStorage.getItem("accessToken")
          const reponse = await axios.post(`${baseUrl}api/orders/cancel/${id}` , {withCredentials : true} , {withCredentials : true , headers : {Authorization: `Bearer ${accessToken}`}})
          console.log(reponse)
        }catch(err){
          console.log("error while cancelling the order")
          console.log(err)
        }
      }
      handleCancel()
    }
  }

  // console.log(isDelivered , canReturned)
  // console.log(props)

  return (
    <div className="border border-gray-200 rounded-md bg-white mb-6 overflow-hidden">
      {/* Order Header */}
      <div className="grid grid-cols-3 gap-4 p-4 bg-gray-50 border-b border-gray-200 text-xs  md:text-sm">
        <div>
          <p className="text-gray-500 font-medium">ORDER PLACED</p>
          <p>{orderDate}</p>
        </div>
        <div>
          <p className="text-gray-500 font-medium">TOTAL</p>
          <p>₹{props.total}</p>
        </div>
        <div>
          <p className="text-gray-500 font-medium">SHIP TO</p>
          <p className="text-blue-600 flex items-center">
            {props.order.address[0]?.fullName || "Customer"}
            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 ml-1" viewBox="0 0 20 20" fill="currentColor">
              {/* <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" /> */}
            </svg>
          </p>
        </div>
        <div className="col-span-3 flex justify-between items-center mt-2">
          <p className="text-gray-500 flex gap-5">ORDER # {props._id.substr(-8)}
             <StatusBadge status={orderStatus} />
          </p>
          <div className="flex space-x-4">
            {/* <button className="text-blue-600 hover:underline text-sm">View order details</button> */}
            { !isCancelled && !isPlaced &&
              <button onClick={handleInvoice}  className="text-blue-600 hover:underline text-sm flex items-center">
                Invoice
              </button>
            }
          </div>
        </div>
      </div>

      {/* Order Status */}
      <div className="p-4">
        <div className="flex flex-col md:flex-row md:justify-between md:items-start">
          <div className="mb-4 md:mb-0">
            <h3 className="font-bold text-sm md:text-lg">
              {isDelivered && "Delivered"} 
              {isShipped && "Shipped"} 
              {isProcessing && "Processing"} 
              {isCancelled && "Cancelled"}
              {isPlaced && "Placed"}
              {returnRequested && "Return Requested"}
              {returnApproved && "Return Approved"}
              {returnInitiated && "Return Pickup Initiated"}
              {refunded && "Refunded"}
              {returnInProgress && "Picked Up"}
              {returnRejected && "Return Rejected"}
            </h3>
            {isPlaced && <p className="text-xs md:text-sm text-gray-600">Your order is placed</p>}
            {isDelivered && <p className="text-xs md:text-sm text-gray-600">Package was handed to resident on {deliveryDate}</p>}
            {isShipped && <p className="text-xs md:text-sm text-gray-600">Your package is on the way</p>}
            {isProcessing && <p className="text-xs md:text-sm text-gray-600">Your order is being processed</p>}
            {isCancelled && <p className="text-xs md:text-sm text-gray-600">This order has been cancelled</p>}
            {returnRequested && <p className="text-xs md:text-sm text-gray-600">Awaiting Confirmation</p>}
            {returnApproved && <p className="text-xs md:text-sm text-gray-600">Pickup will be initiated shortly.</p>}
            {returnInitiated && <p className="text-xs md:text-sm text-gray-600">Product will be picked up shortly.</p>}
            {refunded && <p className="text-xs md:text-sm text-gray-600">Refund will be credited shortly, if it was a COD order contact us on whatsapp</p>}
            {returnInProgress && <p className="text-xs md:text-sm text-gray-600">Item has been picked up</p>}
            {returnRejected && <p className="text-xs md:text-sm text-gray-600">Return request was rejected, contact us on whatsapp</p>}
          </div>
          
          {/* Action Buttons - right aligned on desktop, below status on mobile */}
          <div className="flex flex-wrap gap-2 mt-2 md:mt-0 md:justify-end">
            {/* Always show View Order button */}
            <a 
              href={`order/${props._id}`} 
              className="border border-gray-300 rounded-full py-2 px-4 text-xs md:text-sm font-medium hover:bg-gray-100 transition-colors"
            >
              View Order
            </a>
            
            {/* Conditionally show Track Package button */}
            {showTrackPackage && (
              <a 
                href={`${props.order.tracking}`} 
                className="border border-gray-300 rounded-full py-2 px-4 text-xs md:text-sm font-medium hover:bg-gray-100 transition-colors"
                target="_blank" 
                rel="noopener noreferrer"
              >
                Track Package
              </a>
            )}
            
            {/* Conditionally show Cancel Order button */}
            {showCancelOrder && (
              <button 
                onClick={() => HandleCancel(props.order)} 
                className="border border-gray-300 rounded-full py-2 px-4 text-xs md:text-sm font-medium hover:bg-gray-100 transition-colors text-red-600"
              >
                Cancel Order
              </button>
            )}
            
            {/* Conditionally show Return button */}
            {showReturn && (
              <a 
                href={`/return/${props._id}`} 
                className="border border-gray-300 rounded-full py-2 px-4 text-xs md:text-sm font-medium hover:bg-gray-100 transition-colors"
              >
                Return
              </a>
            )}
          </div>
        </div>
      </div>

      {/* Products */}
      <div className="px-4 pb-4 border-t border-gray-200 pt-2">
        {props.order.cart.map((item) => (
          <ParticularOrder
            key={item._id}
            name={item.title}
            price={item.price}
            img={item.image}
            productId={item.productId}
            size={item.size}
            quantity={item.quantity}
          />
        ))}
        
        {isDelivered && (
          <div className="mt-2 text-sm text-gray-600">
            Return or replace items: Eligible through {returnDate}
          </div>
        )}
        
        {/* <div className="mt-4">
          <button className="border border-gray-300 rounded-full py-1.5 px-6 text-sm font-medium hover:bg-gray-100 transition-colors">
            View your item
          </button>
        </div> */}
      </div>
      
      {/* Archive button */}
      {/* <div className="p-4 border-t border-gray-200">
        <button className="text-blue-600 hover:underline text-sm">
          Archive order
        </button>
      </div> */}
    </div>
  );
}

function Orders({ orders }) {
  return (
    <div className="space-y-6 ">
      {orders.map((order) => (
        <ProductOrdered
          key={order._id}
          order={order}
          status={order.status}
          _id={order._id}
          total={order.totalAmount}
        />
      ))}
    </div>
  );
}

function OrderPage() {
  React.useEffect(() => {
      document.title = "Jutexx | Orders";
  }, []);
  const navigate = useNavigate();

React.useEffect(() => {
  const getUser = async () => {
    try {
      const accessToken = localStorage.getItem("accessToken"); 
      await axios.get(`${baseUrl}api/auth/isLoggedIn`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
        withCredentials: true, 
      });
    } catch (err) {
      navigate("/login");
      console.log("error while checking if logged in");
      console.log(err);
    }
  };
  getUser();
}, [navigate]);


  const [orders, setOrders] = React.useState([]);
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    async function getOrders() {
      try {
        const accessToken = localStorage.getItem("accessToken")
        const response = await axios.post(`${baseUrl}api/orders/get-orders` , {} , {
          withCredentials : true ,
          headers : {
            Authorization : `Bearer ${accessToken}`,
            'Content-Type': 'application/json',
          }
        })

        setOrders((response?.data?.data).reverse());
        setLoading(false);
      } catch (err) {
        console.log("error fetching orders list");
        setLoading(false);
      }
    }
    getOrders();
  }, []);

  return (
    <div className="min-h-screen bg-[#FAF9F8] flex flex-col">
      <Navbar />
      <div className="flex-grow container mx-auto px-4 py-8 max-w-5xl">
        <h1 className="text-2xl font-bold text-gray-800 mb-6">Your Orders</h1>
        
        {loading && <OrdersSkeleton />}

        {!loading && orders.length > 0 && <Orders orders={orders} />}
        
        {!loading && orders.length === 0 && (
          <div className="text-center py-12 bg-white rounded-md shadow-sm border border-gray-200">
            <h3 className="text-xl font-semibold text-gray-800 mb-2">
              We're Sorry
            </h3>
            <p className="text-gray-600 mb-6">
              When you have bought something online you'll find it here.
            </p>
            <Link 
              to="/" 
              className="inline-block bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-6 rounded-md transition-colors"
            >
              Continue Shopping
            </Link>
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
}

export default OrderPage;